import React from 'react';

const StatusDisplay = ({ status, label = 'Status' }) => (
  <div className="flex header-item">
    <strong className="text-muted m-r-12">{label}: </strong>
    <strong className={`${status && status.archived ? 'text-muted' : ''}`}>
      {status ? status.name : '—'}
    </strong>
  </div>
);

export default StatusDisplay;
